/*
 * Copyright Amazon.com, Inc. and its affiliates. All Rights Reserved.
 * SPDX-License-Identifier: MIT
 *
 * Licensed under the MIT License. See the LICENSE accompanying this file
 * for the specific language governing permissions and limitations under
 * the License.
 */

import { AmplifySignIn } from '@aws-amplify/ui-react';
import React from 'react';
import { connect } from 'react-redux';

const mapStateToProps = (state) => {
	return {
		lang: state.app.lang
	};
};

const customInputStyle = {
	border: '1px solid #B4C6D4',
	borderRadius: '3px',
	padding: '24px 15px',
	fontSize: '18px',
	fontWeight: '500',
	lineHeight: '24px',
	color: '#B4C6D4',
	'&::placeholder': {
		color: '#B4C6D4'
	}
};

const Login = ({ lang }) => {
	const [email, setEmail] = React.useState('');
	const [password, setPassword] = React.useState('');

	React.useEffect(() => {
		setEmail('');
		setPassword('');
	}, [lang]);

	return (
		<AmplifySignIn
			className="login"
			headerText=""
			usernameAlias="email"
			slot="sign-in"
			formFields={[
				{
					type: 'email',
					required: true,
					value: email,
					inputProps: {
						'data-test': 'sign-in-email-input',
						/* 'style': customInputStyle, */
						onChange: (e) => setEmail(e.target.value)
					}
				},
				{
					type: 'password',
					required: true,
					value: password,
					inputProps: {
						'data-test': 'sign-in-password-input',
						/* 'style': customInputStyle, */
						onChange: (e) => setPassword(e.target.value)
					}
				}
			]}
		>
			<div slot="federated-buttons"></div>
			<div slot="secondary-footer-content"></div>
		</AmplifySignIn>
	);
};

export default connect(mapStateToProps, {})(Login);
